const baseRoute = 'communication-pipeline/:moduleBridgeHex/';
const userRoute = `${baseRoute}user/`;
const userReportRoute = `${baseRoute}user/report/:reportHex/`;
const userEnquiryRoute = `${baseRoute}user/inquiry/:inquiryHex/`;

export default {
  user_module_communicationPipeline_base: {
    path: baseRoute,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_communicationPipeline_home: {
    path: `${baseRoute}home/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  // USER
  user_module_communicationPipeline_user_base: {
    path: `${userRoute}`,
    parameters: {
      moduleBridgeHex: undefined,
      reportHex: undefined,
    },
  },
  user_module_communicationPipeline_user_report_base: {
    path: `${userReportRoute}`,
    parameters: {
      moduleBridgeHex: undefined,
      reportHex: undefined,
    },
  },
  user_module_communicationPipeline_user_inquiry_base: {
    path: `${userEnquiryRoute}`,
    parameters: {
      moduleBridgeHex: undefined,
      reportHex: undefined,
    },
  },
  user_module_communicationPipeline_user_report_add: {
    path: `${userRoute}add/report/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_communicationPipeline_user_report_sent: {
    path: `${userReportRoute}sent/`,
    parameters: {
      moduleBridgeHex: undefined,
      reportHex: undefined,
    },
  },
  user_module_communicationPipeline_user_report_status: {
    path: `${userReportRoute}status/`,
    parameters: {
      moduleBridgeHex: undefined,
      reportHex: undefined,
    },
  },
  user_module_communicationPipeline_user_report_thread: {
    path: `${userReportRoute}thread/`,
    parameters: {
      moduleBridgeHex: undefined,
      reportHex: undefined,
    },
  },
  user_module_communicationPipeline_user_report_communication: {
    path: `${userReportRoute}thread/:threadHex/communication/`,
    parameters: {
      moduleBridgeHex: undefined,
      reportHex: undefined,
      threadHex: undefined,
    },
  },
  user_module_communicationPipeline_user_inquiry_add: {
    path: `${userRoute}add/inquiry/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_communicationPipeline_user_inquiry_communication: {
    path: `${userEnquiryRoute}communication/`,
    parameters: {
      moduleBridgeHex: undefined,
      inquiryHex: undefined,
    },
  },
  // ADMIN
  user_module_communicationPipeline_admin_report_status: {
    path: `${baseRoute}admin/report/status/:reportHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      reportHex: undefined,
    },
  },
  user_module_communicationPipeline_admin_report_sent: {
    path: `${baseRoute}admin/report/sent/:reportHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      reportHex: undefined,
    },
  },
  user_module_communicationPipeline_admin_report_sign: {
    path: `${baseRoute}admin/report/sign/:reportHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      reportHex: undefined,
    },
  },
  user_module_communicationPipeline_admin_report_processing: {
    path: `${baseRoute}admin/report/processing/:reportHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      reportHex: undefined,
    },
  },
  user_module_communicationPipeline_admin_report_subjectToAppeal: {
    path: `${baseRoute}admin/report/subject-to-appeal/:reportHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      reportHex: undefined,
    },
  },
  user_module_communicationPipeline_admin_report_allegations: {
    path: `${baseRoute}admin/report/allegations/:reportHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      reportHex: undefined,
    },
  },
  user_module_communicationPipeline_admin_report_end: {
    path: `${baseRoute}admin/report/end/:reportHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      reportHex: undefined,
    },
  },
  user_module_communicationPipeline_admin_report_thread: {
    path: `${baseRoute}admin/report/:reportHex/thread/`,
    parameters: {
      moduleBridgeHex: undefined,
      reportHex: undefined,
    },
  },
  user_module_communicationPipeline_admin_report_communication: {
    path: `${baseRoute}admin/report/:reportHex/thread/:threadHex/communication/`,
    parameters: {
      moduleBridgeHex: undefined,
      reportHex: undefined,
      threadHex: undefined,
    },
  },
  user_module_communicationPipeline_admin_inquiry_list: {
    path: `${baseRoute}admin/inquiry/list/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_communicationPipeline_admin_inquiry_communication: {
    path: `${baseRoute}admin/inquiry/:inquiryHex/communication/`,
    parameters: {
      moduleBridgeHex: undefined,
      inquiryHex: undefined,
    },
  },
};
